import React from 'react';
import { Text, useWindowDimensions, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { CustomModal } from '../customModal';
import { ImageComp } from '../Image/Image';
import CustomPressable from '../customPressable/customPressable';
import { useCssStyle } from '../../customHook/getCssStyle';
import { setRenderWidgetInfoModal } from '../../Redux/Actions/appConfigAction';
import { getCleanUrl } from '../../utils/Helper';
import RenderHTML from 'react-native-render-html';

const InfoModalWidget_Potrait = () => {
    const {width} = useWindowDimensions();

    const dispatch = useDispatch();
    const getStyles = useCssStyle();
    const { modalData } = useSelector(state => state.appConfigSlice.renderWidgetInfoModal);
    const widgetMetaHtmlId = modalData?.widgetMetaHtmlId;

    const handleClose = () => {
        dispatch(setRenderWidgetInfoModal(false));
    };

    const customGuestRequestHeaderTitleStyle = getStyles(['widgetInfoModalTitle', `widgetInfoModalTitle_${widgetMetaHtmlId}`]);
    const customGuestRequestTitleStyle = getStyles(['widgetInfoModalDescription', `widgetInfoModalDescription_${widgetMetaHtmlId}`]);

    return (
        <CustomModal onRequestClose={handleClose}>
            <View style={getStyles(['widgetInfoModalContainer'])} id="widgetInfoModalContainer">
                {/* Header Image */}
                {modalData?.widgetHeaderImageUrl && (
                    <View style={getStyles(['widgetInfoModalImageWrapper'])} id="widgetInfoModalImageWrapper">
                        <ImageComp
                            source={getCleanUrl(modalData.widgetHeaderImageUrl)}
                            style={getStyles(['widgetInfoModalHeaderImage'])}
                            id="widgetInfoModalHeaderImage"
                        />
                    </View>
                )}

                {/* Close Button */}
                <CustomPressable
                    onPress={handleClose}
                    style={getStyles(['widgetInfoModalCloseBtn'])}
                    id="widgetInfoModalCloseBtn"
                >
                    <Text style={getStyles(['widgetInfoModalCloseBtnTxt'])} id="widgetInfoModalCloseBtnTxt">
                        ✕
                    </Text>
                </CustomPressable>

                {/* Content */}
                <View style={getStyles(['widgetInfoModalContent'])} id="widgetInfoModalContent">
                    {modalData?.contentTitle && (
                        <RenderHTML 
                            contentWidth={width}
                            baseStyle={Array.isArray(customGuestRequestHeaderTitleStyle.fontFamilyArr) ? {...customGuestRequestHeaderTitleStyle, fontFamily: customGuestRequestHeaderTitleStyle.fontFamilyArr[0]} : customGuestRequestHeaderTitleStyle}
                            source={{html: modalData?.contentTitle}}
                            systemFonts={ Array.isArray(customGuestRequestHeaderTitleStyle.fontFamilyArr) ? customGuestRequestHeaderTitleStyle.fontFamilyArr : [customGuestRequestHeaderTitleStyle.fontFamily]}
                            id={`widgetInfoModalTitle`}
                        />
                    )}
                    {modalData?.contentDescription && (
                        <RenderHTML
                            contentWidth={width}
                            baseStyle={Array.isArray(customGuestRequestTitleStyle.fontFamilyArr) ? {...customGuestRequestTitleStyle, fontFamily: customGuestRequestTitleStyle.fontFamilyArr[0]} : customGuestRequestTitleStyle}
                            source={{html: modalData?.contentDescription}}
                            systemFonts={ Array.isArray(customGuestRequestTitleStyle.fontFamilyArr) ? customGuestRequestTitleStyle.fontFamilyArr : [customGuestRequestTitleStyle.fontFamily]}
                            id={`widgetInfoModalDescription`}
                        />
                    )}
                </View>
            </View>
        </CustomModal>
    );
};

export default InfoModalWidget_Potrait;
